import { useTranslation, Trans } from "react-i18next";

import e1 from '../../img/Home/e1.png'
import e2 from '../../img/Home/e2.png'
import e3 from '../../img/Home/e3.png'

function EverythingNeed() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
           <p className="text-[#061A77] font-[500] leading-[1.2] poppins text-[28px] xl:text-[48px] xl:max-w-[533px]">{t('home.30')}</p>
            <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px] mt-[30px] xl:mt-[40px]">
                <img src={e1} className="rounded-[4px]" alt="" />
                <div className="rounded-[4px] border w-full flex flex-col justify-center items-center">
                    <div className="px-[20px] py-[40px]">
                        <p className="poppins xl:text-[32px] text-[20px] leading-[1.2] text-[#1A0402] font-[500]">{t('home.31')}</p>
                        <p className="inter text-[14px] text-[#000000B2] xl:max-w-[290px] mt-[10px] xl:mt-[20px]">{t('home.32')}</p>
                    </div>
                </div>
            </div>
            <div className="flex flex-col xl:flex-row-reverse gap-[10px] xl:gap-[20px] mt-[10px] xl:mt-[20px]">
                <img src={e2} className="rounded-[4px]" alt="" />
                <div className="rounded-[4px] border w-full flex flex-col justify-center items-center">
                    <div className="px-[20px] py-[40px]">
                        <p className="poppins xl:text-[32px] text-[20px] leading-[1.2] text-[#1A0402] font-[500]">{t('home.33')}</p>
                        <p className="inter text-[14px] text-[#000000B2] xl:max-w-[290px] mt-[10px] xl:mt-[20px]">{t('home.34')}</p>
                    </div>
                </div>
            </div>
            <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px] mt-[10px] xl:mt-[20px]">
                <img src={e3} className="rounded-[4px]" alt="" />
                <div className="rounded-[4px] border w-full flex flex-col justify-center items-center">
                    <div className="px-[20px] py-[40px]">
                        <p className="poppins xl:text-[32px] text-[20px] leading-[1.2] text-[#1A0402] font-[500]">{t('home.35')}</p>
                        <p className="inter text-[14px] text-[#000000B2] xl:max-w-[290px] mt-[10px] xl:mt-[20px]">{t('home.36')}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default EverythingNeed;
 